import React, { useState } from 'react';
// 🛠️ CRITICAL FIX: @mui/lab चा पॅकेज पूर्णपणे काढून सोपे इन-बिल्ट लेआउट्स वापरले ✅
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import SearchIcon       from '@mui/icons-material/SearchRounded';
import ArrowBackIcon    from '@mui/icons-material/ArrowBackRounded';
import PhoneIcon        from '@mui/icons-material/PhoneAndroidRounded';
import PersonCheckIcon  from '@mui/icons-material/HowToRegRounded';
import CurrencyIcon     from '@mui/icons-material/CurrencyRupeeRounded';
import GroupAddIcon     from '@mui/icons-material/GroupAddRounded';
import StarIcon         from '@mui/icons-material/StarRounded';
import HistoryIcon      from '@mui/icons-material/ManageHistoryRounded';
import { useNavigate } from "react-router-dom"; // 👈 ही लाईन वरती जोडा

// Sample quick-search members — replace with API call
const QUICK_MEMBERS = [
  { mobile: '9876543210', name: 'Rahul Sharma',    pkg: 'Gold',     status: 'Active' },
  { mobile: '9123456780', name: 'Priya Desai',     pkg: 'Silver',   status: 'Active' },
  { mobile: '9988776655', name: 'Sanjay Patil',    pkg: 'Platinum', status: 'Inactive' },
];

// Dot colors mapping as per MUI palette standard tokens
const DOT_COLORS = {
  primary: '#1d4ed8',
  success: '#22c55e',
  warning: '#f59e0b',
  error: '#ef4444'
};

const HISTORY = [
  { dot: 'primary',  icon: <PersonCheckIcon fontSize="small"/>, title: 'Registration completed',      meta: '01 Jan 2024 — Reference: 9000000001', tag: 'New Member', tagColor: '#eef2ff', tagText: '#3730a3' },
  { dot: 'success',  icon: <CurrencyIcon fontSize="small"/>,   title: 'Payment received — ₹1,999',   meta: '02 Jan 2024 — Gold Package activation', tag: 'Payment', tagColor: '#dcfce7', tagText: '#166534' },
  { dot: 'warning',  icon: <GroupAddIcon fontSize="small"/>,   title: 'Referral joined — Priya Desai', meta: '15 Feb 2024 — Downline Level 1',      tag: 'Referral', tagColor: '#fffbeb', tagText: '#92400e' },
  { dot: 'success',  icon: <CurrencyIcon fontSize="small"/>,   title: 'Commission credited — ₹400',  meta: '16 Feb 2024 — Level 1 commission',    tag: 'Commission', tagColor: '#dcfce7', tagText: '#166534' },
  { dot: 'warning',  icon: <GroupAddIcon fontSize="small"/>,   title: 'Referral joined — Sanjay Patil', meta: '10 Mar 2024 — Downline Level 1',    tag: 'Referral', tagColor: '#fffbeb', tagText: '#92400e' },
  { dot: 'error',    icon: <StarIcon fontSize="small"/>,       title: 'Package upgraded — Silver → Gold', meta: '20 Mar 2024 — Upgrade ₹1,000',   tag: 'Upgrade', tagColor: '#eef2ff', tagText: '#3730a3' },
];

function initials(name) {
  return name.split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase();
}

export default function AccountHistory() { // 👈 Props मधून onNavigate काढला
  
  const navigate = useNavigate(); // 🚀 React Router चा नॅव्हिगेशन हुक सुरू केला
  const [mobile, setMobile]   = useState('');
  const [member, setMember]   = useState(null);

  const handleSearch = () => {
    if (mobile.trim().length < 10) { alert('Enter valid 10-digit mobile.'); return; }
    const found = QUICK_MEMBERS.find((m) => m.mobile === mobile.trim());
    setMember(found || { mobile: mobile.trim(), name: 'Unknown Member', pkg: '—', status: 'Active' });
  };

  const handleQuick = (m) => { setMobile(m.mobile); setMember(m); };

  return (
    <Box>
      {/* Search card */}
      <Card sx={{ mb: 2 }}>
        <CardContent sx={{ p: 2.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2,
            pb: 1.5, borderBottom: '1px solid #f1f5f9' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
              <Box sx={{ width: 30, height: 30, borderRadius: 2,
                background: '#eff6ff', color: '#1d4ed8',
                display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <PhoneIcon fontSize="small" />
              </Box>
              <Box>
                <Typography variant="h6">Enter Mobile Number</Typography>
                <Typography variant="caption" color="text.secondary">
                  Search member account &amp; history
                </Typography>
              </Box>
            </Box>
            <Button size="small" startIcon={<ArrowBackIcon />}
              onClick={() => navigate('/dashboard/registration')} // 👈 हे करा, एरर कायमचा निघून जाईल! ✅
              sx={{ color: '#374151', borderColor: '#e2e8f0', border: '1px solid',
                borderRadius: 2, px: 1.5, background: '#f8fafc',
                '&:hover': { background: '#f1f5f9' }, fontSize: '0.75rem' }}>
              Back to Form
            </Button>
          </Box>

          {/* Search bar */}
          <Box sx={{ display: 'flex', gap: 1, mb: 1.5 }}>
            <TextField fullWidth size="small" placeholder="Enter 10-digit mobile number..."
              value={mobile} onChange={(e) => setMobile(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()} />
            <Button variant="contained" onClick={handleSearch}
              startIcon={<SearchIcon />}
              sx={{ background: '#0f172a', '&:hover': { background: '#1e293b' },
                whiteSpace: 'nowrap', px: 2.5, borderRadius: 2 }}>
              Search
            </Button>
          </Box>

          {/* Quick chips */}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
            <Typography variant="caption" color="text.secondary">Quick:</Typography>
            {QUICK_MEMBERS.map((m) => (
              <Chip key={m.mobile} label={m.mobile} size="small" onClick={() => handleQuick(m)}
                sx={{ background: '#eef2ff', color: '#3730a3',
                  border: '1px solid #c7d2fe', cursor: 'pointer',
                  '&:hover': { background: '#e0e7ff' } }} />
            ))}
          </Box>
        </CardContent>
      </Card>

      {/* Member result */}
      {member && (
        <>
          {/* Member banner */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.8, p: 2,
            background: '#1e1b4b', borderRadius: 3, mb: 2 }}>
            <Avatar sx={{ width: 46, height: 46, background: '#4338ca',
              color: '#c7d2fe', fontWeight: 500, border: '2px solid #6366f1' }}>
              {initials(member.name)}
            </Avatar>
            <Box>
              <Typography sx={{ color: '#f1f5f9', fontWeight: 500, fontSize: '0.9375rem' }}>
                {member.name}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.3 }}>
                <PhoneIcon sx={{ fontSize: 12, color: '#a5b4fc' }} />
                <Typography sx={{ color: '#a5b4fc', fontSize: '0.75rem' }}>
                  {member.mobile}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ ml: 'auto', display: 'flex', flexDirection: 'column', gap: 0.7, alignItems: 'flex-end' }}>
              <Chip label={member.status} size="small"
                sx={{ background: '#22c55e', color: '#fff', fontWeight: 500, height: 22 }} />
              <Chip label={`📦 ${member.pkg}`} size="small"
                sx={{ background: 'rgba(99,102,241,0.35)', color: '#c7d2fe', height: 22 }} />
            </Box>
          </Box>

          {/* History timeline card */}
          <Card>
            <CardContent sx={{ p: 2.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 3,
                pb: 1.5, borderBottom: '1px solid #f1f5f9' }}>
                <Box sx={{ width: 30, height: 30, borderRadius: 2,
                  background: '#fffbeb', color: '#b45309',
                  display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <HistoryIcon fontSize="small" />
                </Box>
                <Box>
                  <Typography variant="h6">Account History</Typography>
                  <Typography variant="caption" color="text.secondary">
                    All activity on this account
                  </Typography>
                </Box>
              </Box>

              {/* 🛠️ CUSTOM ACCURATE TIMELINE ENGINE — NO CODES ALTERED */}
              <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                {HISTORY.map((h, i) => (
                  <Stack direction="row" key={i} sx={{ minHeight: 75, position: 'relative' }}>
                    
                    {/* Left Connector and Node Point Container */}
                    <Stack alignItems="center" sx={{ mr: 2, position: 'relative' }}>
                      {/* Timeline Circular Dot node replacement */}
                      <Box sx={{
                        width: 28,
                        height: 28,
                        borderRadius: '50%',
                        backgroundColor: DOT_COLORS[h.dot] || '#cbd5e1',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 2,
                        boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                      }}>
                        {h.icon}
                      </Box>
                      
                      {/* Vertical line connector calculation bridge */}
                      {i < HISTORY.length - 1 && (
                        <Box sx={{
                          width: '2px',
                          backgroundColor: '#cbd5e1',
                          position: 'absolute',
                          top: 28,
                          bottom: -6,
                          left: '50%',
                          transform: 'translateX(-50%)',
                          zIndex: 1
                        }} />
                      )}
                    </Stack>

                    {/* Right side content layout exactly identical */}
                    <Box sx={{ pt: 0.2, pb: 2, flexGrow: 1 }}>
                      <Typography sx={{ fontSize: '0.8125rem', fontWeight: 500, color: '#0f172a', lineHeight: 1.3 }}>
                        {h.title}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.2 }}>
                        {h.meta}
                      </Typography>
                      <Box sx={{ mt: 0.5 }}>
                        <Chip label={h.tag} size="small"
                          sx={{ background: h.tagColor, color: h.tagText, height: 18, fontSize: '0.625rem', fontWeight: 500 }} />
                      </Box>
                    </Box>

                  </Stack>
                ))}
              </Box>

            </CardContent>
          </Card>
        </>
      )}
    </Box>
  );
}